module.exports = __webpack_public_path__ + "static/media/trx.db747321.png";